import api from "./axios";

export const callRequestStatusApi = async ({ to_user, status }) => {
  const payload = new FormData();
  payload.append("to_user", to_user);
  payload.append("status", status); // 2 | 3

  const { data } = await api.post(
    "/chat/call-request-status-update/",
    payload,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  if (!data.success) {throw new Error(data.message || "Failed to update call request");}
  return data.data || {};
};
